/**
 * tabbar.js
 *
 * @category   Widget Tabbar
 * @copyright  Copyright (c) 2019 CHECK24 Vergleichsportal Reise GmbH
 * @since      31.07.2017
 */

import '../css/tabbar.scss';

class TabBar {

    tabBarClass: string;

    tabBarBodyClass: string;

    tabBarBodyListClass: string;

    tabBarBodyContentsClass: string;

    tabBarBodyContentClass: string;

    tabBarBodyContentTabClass: string;

    tabBarBodyLinkClass: string;

    bodies: NodeListOf<HTMLDivElement>;

    constructor() {
        this.tabBarClass = 'wdgt-Tabbar';
        this.tabBarBodyClass = 'tabbar-body';
        this.tabBarBodyListClass = 'tab-list';
        this.tabBarBodyContentsClass = 'tab-contents';
        this.tabBarBodyContentClass = 'tab-content';
        this.tabBarBodyContentTabClass = 'content-tab';
        this.tabBarBodyLinkClass = 'tabbar-link';
        this.bodies = document.querySelectorAll(`.${this.tabBarBodyClass}`);
        this.init();
        this.changeTabOnHashHit();
    }

    init() {
        this.bodies.forEach((tb) => {
            const tabList = tb.querySelector(`.${this.tabBarBodyListClass}`);
            const tabContents = tb.querySelector(`.${this.tabBarBodyContentsClass}`);
            const tabBarLinks = tabList?.querySelectorAll(`.${this.tabBarBodyLinkClass}`);

            if (tabList && tabContents) {
                tabBarLinks?.forEach((link) => {
                    link.addEventListener('click', (e: Event) => {
                        if (e.currentTarget) {
                            this.onTabClick(e.currentTarget as HTMLElement, tabList, tabContents);
                        }
                    });
                });
            }
        });
    }

    onTabClick(targetElem: HTMLElement, tabList: Element, tabContents: Element) {
        if (targetElem) {
            const idSelector = targetElem.getAttribute('data-tab-target');

            if (!idSelector) {
                return;
            }
            const target = document.querySelector(idSelector);
            const activeClass = 'active-tab';
            const contentTabs = tabList?.querySelectorAll(`.${this.tabBarBodyContentTabClass}`);
            const newActiveTab = targetElem.parentNode as HTMLElement;

            contentTabs &&
            contentTabs.forEach((tab) => {
                tab.classList.remove(activeClass);
            });

            if (newActiveTab) {
                newActiveTab.classList.add(activeClass);
            }

            const tabContentElem = tabContents?.querySelectorAll(`.${this.tabBarBodyContentClass}`);

            if (tabContentElem) {
                tabContentElem.forEach((tabContent) => {
                    tabContent.classList.remove(activeClass);
                });
            }
            target?.classList.add(activeClass);
        }
    }

    changeTabOnHashHit() {
        const hash = window.location.hash ? (window.location.hash.match(/([#]\w+[^?]+)/g)?.[0] ?? null) : null;

        if (hash) {
            const targetElement = document.querySelector(hash);
            // Get closest tab content if available
            const tabContentParent = targetElement?.closest('.tab-content');

            if (tabContentParent) {
                const tabButtonElem = document.querySelector(
                    '.content-tab span[data-tab-target="#' + tabContentParent.id + '"]'
                ) as HTMLElement | null;

                if (tabButtonElem) {
                    tabButtonElem.click();
                }
            }
        }
    }

}

export default TabBar;
export { TabBar };
